var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},[React.createElement("path",{"d":"M87.0406 159.749C126.88 159.749 159.176 127.436 159.176 87.5758C159.176 47.7156 126.88 15.4025 87.0406 15.4025C47.2011 15.4025 14.9048 47.7156 14.9048 87.5758C14.9048 127.436 47.2011 159.749 87.0406 159.749Z","stroke":"#C7C7C7","strokeWidth":"6","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M72.6143 58.7064L115.896 87.5758L72.6143 116.445V58.7064Z","stroke":"#C7C7C7","strokeWidth":"6","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Play.defaultProps = {"width":"174","height":"175","viewBox":"0 0 174 175","fill":"none"};

module.exports = Play;

Play.default = Play;
